import AssessmentModal from './AssessmentModal';

export default AssessmentModal;
